export const environment = {
    production: false,
    dgitl: false,
    ps4: false,
    dmu: false,
    deps: false,
    dgaspc: true,
    config: {
        appName: 'DGASPC Sector 4',
        appNameSmall: 'PS 4',
        appDescription: 'inDoc - DBMS',
        appDescriptionSmall: 'indoc',
        appLogoUrl: 'assets/images/dgaspc-logo.svg',
        fromTokenValid: 'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-staging-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © DGASPC Sector 4 București <br/>2018 - 2025',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Success',
                error: 'Eroare',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rău, dar am întâmpinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioara',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
        sources: {
            1: {
                label: 'DGASPC',
                color: '#fff',
                bgColor: '#2872be',
                appUrl: 'https://development.dgaspc.webproductionlabs.com/'
            }
        }
    },
    interop: {
        basePath: 'https://development.indoc-core.webproductionlabs.com/',
        clientId: 1,
        moduleId: 6,
        dgaspcId: 22,
        indoc: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/registratura/auth-notifications',
            },
            user: {
                getUserAccess: 'api/directii/users',
                // getUsersDirectieCompartiment: 'api/indoc-access-user-auth',
                // getDirectii: 'api/directii',
                // getCompartiment: 'api/compartimente',
                // getCompartimentByDirectie: 'api/compartimente/search/', // + id directie
                getActiveUsersByOrganigrama: 'api/user/list-users-organigrama',
                getUsersListModuleColeagues: 'api/registratura/user/list-module-coleagues'
            },
            functiiUser: {
                list: 'api/functie/list',
                listActive: 'api/functie/list/active',
            },
            directie: {
                getDirectii: 'api/directie/list',
                getDirectiiActive: 'api/directie/list/active',
            },
            compartiment: {
                getCompartimente: 'api/directie-compartiment/list',
                getCompartimenteActive:
                    'api/directie-compartiment/list/active',
                getCompartimenteByDirectie:
                    'api/directie-compartiment/listByDirectie/',

                searchCompartimente:
                    'api/compartimente/name-search/list',
                searchCompartimenteActive:
                    'api/compartimente/name-search/active',
            },
            tari: {
                getTari: 'api/settings/address/countries/search',
                getTariActive: 'api/settings/address/countries/active/search',
                getTariPublic: 'api/settings/address/countries/public/search',
            },
            judete: {
                getJudete: 'api/settings/address/judete/search',
                getJudeteActive: 'api/settings/address/judete/active/search',
                getJudetePublic: 'api/settings/address/judete/public/search',
            },
            localitati: {
                getLocalitati: 'api/settings/address/localitati/search',
                getLocalitatiActive: 'api/settings/address/localitati/active/search',
                getLocalitatiPublic: 'api/settings/address/localitati/public/search',
            },
            strazi: {
                getStrazi: 'api/settings/address/strazi/search',
                getStraziActive: 'api/settings/address/strazi/active/search',
                getStraziPublic: 'api/settings/address/strazi/public/search',
                storeStrada: 'api/registratura/strada/store',
            },
            // PLATFORM INDOC
            borderou: {
                getBorderouDT: 'api/registratura/document/borderou/index-dt',
                createBorderou: 'api/registratura/document/create-borderou',
                storeBorderou: 'api/registratura/document/borderou/store',
                storeMultipleBorderou: 'api/registratura/document/borderou/store-multiple',
                viewBorderou: 'api/registratura/document/borderou/view/',
                cancelBorderou: 'api/registratura/document/borderou/cancel/',
                printBorderou: 'api/registratura/document/borderou/print/',
            },
            sabloane: {
                getSabloaneDT: 'api/registratura-sabloane-list',
                getSabloane: 'api/registratura-sabloane-list',
                deleteSabloane: 'api/registratura-sabloane/',
                storeSabloane: 'api/registratura-sabloane',
                findSabloane: 'api/registratura-sabloane/',
                updateSabloane: 'api/registratura-sabloane',
            },
            entitati: {
                getEntitatiDT: 'api/registratura/entities/list-dt',
                viewEntitati: 'api/registratura/entities/view/',
                searchEntitati: 'api/registratura/entities/search',
                searchEntitatiExtern: 'api/registratura/entities/search-extern',
                searchEntitatiByCNP: 'api/registratura/entities/search-cnp-cif',
            },
            verificareEvidenta: {
                getVerificareEvidentaDT: 'api/registratura/verificare-evidenta/list-dt',
                getVerificareEvidenta: 'api/registratura/verificare-evidenta/list',
                findVerificareEvidenta: 'api/registratura/verificare-evidenta/',
                deleteVerificareEvidenta: 'api/registratura/verificare-evidenta/',
            },
            decedati: {
                getDecedatiDT: 'api/registratura/decedati/list-dt',
                getDecedati: 'api/registratura/decedati/list',
                deleteDecedati: 'api/registratura/decedati/',
                storeDecedati: 'api/registratura/decedati',
                findDecedati: 'api/registratura/decedati/',
                updateDecedati: 'api/registratura/decedati/',
            },
            rapoarte: {
                getRapoarteDT: 'api/registratura/raport/list-dt',
                generate: 'api/registratura/raport/generate',
            },
            rapoarteActivitati: {
                getRapoarte: 'api/registratura/raport',
            },
            rapoarteActivitatiMatrix: {
                list: 'api/registratura/raport/activity-matrix/list',
                drillDown: 'api/registratura/raport/activity-matrix/drill-down',
                exportCsv: 'api/registratura/raport/activity-matrix/export/csv',
                exportPdf: 'api/registratura/raport/activity-matrix/export/pdf',
            },
            registru: {
                getRegistreDT: 'api/registratura/registru/list-dt',
                getRegistre: 'api/registratura/registru/list',
                downloadTabel: 'api/registratura/registru/download-table',
            },
            inbox: {
                list: 'api/registratura/inbox/list',
                find: 'api/registratura/inbox/find-email/',
                preluare: 'api/registratura/inbox/email-preluare/',
                nepreluare: 'api/registratura/inbox/email-undo-preluare/',
                updateAddress: 'api/registratura/inbox/update-email-address/',
                reply: 'api/registratura/inbox/reply-email',
                redirect: 'api/registratura/inbox/redirect-email',
                favorite: 'api/registratura/inbox/update-favorite/',
                downloadFile: 'api/registratura/inbox/download-file/',
                delete: 'api/registratura/inbox/delete-email/',
                print: 'api/registratura/inbox/email/print/',
                printFile: 'api/registratura/inbox/email-file/print/',
                processFile: 'api/registratura/inbox/process-file-server/', // + id
                processFileAll: 'api/registratura/inbox/process-files-server-all/', // + id
                printEmails: 'api/registratura/inbox/emails/export',
                printEmailThread: 'api/registratura/inbox/emails/thread/', // + id/export
            },
            notificari: {
                email: {
                    getEmailDt: 'api/registratura/email/list-dt',
                    downloadEmail: 'api/registratura/email/view/', // + id
                    resendEmail: 'api/registratura/email/resend/', // + id
                    printNotificari: 'api/registratura/email/print',
                }
            },
            awb: {
                getAwbDt: 'api/registratura/conex/list-dt',
                downloadCSV: 'api/registratura/conex/download-csv-table',
                downloadPDF: 'api/registratura/conex/download-pdf-table',
                downloadPDFAwb: 'api/registratura/conex/download-pdf-awb/', // + id
                deleteAwb: 'api/registratura/conex/delete-awb/', // + id
                deleteAwbPosta: 'api/registratura/conex/delete-awb-posta/', // + id
            },
            documents: {
                getDocumentsListDT: 'api/registratura/document/list-dt-v2',
                search: 'api/registratura/document/search-documente',
                searchAll: 'api/registratura/document/search-all-documente',
                searchTipuri: 'api/registratura/tipuri/search',
                storeDocument: 'api/registratura/document/store/intrare',
                storeApiDocument: 'api/registratura/document/store-api/intrare',
                storeIntern: 'api/registratura/document/store/intern',
                storeIesire: 'api/registratura/document/store/iesire',
                storeApiIesire: 'api/registratura/document/store-api/iesire',

                find: 'api/registratura/document/find/',
                findDocsIesire: 'api/registratura/document/find/iesire',
                mesagerieHistory: 'api/registratura/document/mesagerie/history/',
                exportHistory: 'api/registratura/document/download-history/',
                postMessage: 'api/registratura/document/mesagerie/post-message/',
                updateStatus: 'api/registratura/document/update-status/',
                updatePriority: 'api/registratura/document/update-priority/',
                uploadFile: 'api/registratura/upload-file',
                tempFileDownload: 'api/registratura/document/temp-file-download',
                documentDownloadFile: 'api/registratura/document/download/', // + id
                documentUploadFile: 'api/registratura/document/upload/', // + id
                documentDeleteFile: 'api/registratura/document/delete-file/', // + id_doc/id_file

                invalidare: 'api/registratura/document/invalidare/', // + id
                finalizare: 'api/registratura/document/finalizare/', // + id
                finalizareApi: 'api/registratura/document/finalizare-api/', // + id
                rollBackInchidere: 'api/registratura/document/rollBack-inchidere/', // + id
                updateObservatii: 'api/registratura/document/update-observatii/', // + id
                updateEntity: 'api/registratura/document/update-entity/', // + id
                updateEmitentExtern: 'api/registratura/document/update-emitent-extern/', // + id
                updateInfo: 'api/registratura/document/update-info/', // + id
                addEmitent: 'api/registratura/document/add-emitent/', // + id
                findEntity: 'api/registratura/document/find-entity/', // + id
                removeEntity: 'api/registratura/document/remove-entity/', // + id

                // Activity
                preluareActivity: 'api/registratura/document/activity/preluare/', // + id
                rollBackPreluareActivity: 'api/registratura/document/activity/rollBack-preluare/', // + id
                finalizareActivity: 'api/registratura/document/activity/finalizare/', // + id
                rollBackFinalizareActivity: 'api/registratura/document/activity/rollBack-finalizare/', // + id
                invalidareActivity: 'api/registratura/document/activity/invalidare/', // + id
                activityDestination: 'api/registratura/document/activity/new-destinations/', // + id
                getActivity: 'api/registratura/document/activity/', // + id
                getChildren: 'api/registratura/document/childrens/', // + id
                registerNumberActivityServiciu: 'api/registratura/document/activity/register-number-serviciu/', // + id activity
                removeActivity: 'api/registratura/document/activity/remove/', // + id_activity

                generabile: {
                    downloadTableSignatures: 'api/registratura/document/generabile/download-approval-table/', // id document
                    generateDocument: 'api/registratura/document/generabile/generare-document/', // id => id_cerere, templateId => templateId
                    validateDocument: 'api/registratura/document/generabile/validate-document/', // id
                    validateDocumentSuperior: 'api/registratura/document/generabile/document-validate-superior/', // id => id_cerere, documentId => documentId
                    cancelDocumentSuperior: 'api/registratura/document/generabile/document-anulare-superior/', // id => documentId
                    // validateDocumentByUpload: 'api/cerere/validate-document/', // id document
                    resetDocumentValidated: 'api/registratura/document/generabile/reset-document/', // id document
                    resetDocumentIntocmitorValidated:
                        'api/registratura/document/generabile/reset-document-intocmitor/', // id document
                    uploadedFinalDocument: 'api/registratura/document/generabile/upload-document-oficial/', // id document
                    addToRegistru: 'api/registratura/document/generabile/document-registru-add/', // cerereId, documentId
                    downloadDocumentOfficial: 'api/registratura/document/generabile/download-document-oficial/', // id document
                    downloadDocumentGenerat: 'api/registratura/document/generabile/download-document-generat/', // id document
                    downloadDocumentSigned: 'api/registratura/document/generabile/download-document-signed/', // id => documentId
                    downloadDocumentSignatureSigned:
                        'api/registratura/document/generabile/download-document-signature-signed/', // id => signatureId
                    istoricDocument: 'api/registratura/document/generabile/istoric-document/', // id document
                    destroyDocument: 'api/registratura/document/generabile/destroy-document/', // id document
                    updateDocument: 'api/registratura/document/generabile/update-document/', // id document

                    uploadOnlineDocument: 'api/registratura/document/generabile/upload-online-document/', // id cerere
                    editValabilitateDocGenerabil: 'api/registratura/document/generabile/edit-document-valability/', // + id
                    downloadDocumentAnexa: 'api/registratura/document/generabile/download-document-anexa/', // + id

                    sendDocumentToIntocmitor: 'api/registratura/document/generabile/send-document-back/', // id => signatureId
                    sendDocumentForwardIntocmitor: 'api/registratura/document/generabile/send-document-forward/', // id => documentId
                    sendDocumentForwardToSigner:
                        'api/registratura/document/generabile/send-document-forward-superior/', // id => signatureId

                    rsyncSignaturesDocumentGenerat: 'api/registratura/document/generabile/reload-document-flow/', // id _ documentId

                    sendNotificationCetateanDocumentOficial:
                        'api/registratura/document/generabile/send-document-oficial-notificare-cetatean/', // id document generat - GET request

                    resetDocumentOficialNotificareCetatean:
                        'api/registratura/document/generabile/reset-document-oficial-notificare-cetatean/', // + id
                    resetUploadDocumentOfficial:
                        'api/registratura/document/generabile/reset-upload-document-official/', // + id

                    setCetateanExemplar: 'api/registratura/document/generabile/set-cetatean-exemplar/', // + id document generat
                    setDocTypeForDocument: 'api/registratura/document/generabile/manually-doc-type/', // + id document generat
                    updateCurrentSignatureDocument: 'api/registratura/document/generabile/manually-update-user-validation/', // + id document generat

                    // Document Seal endpoints
                    seal: {
                        checkRegistruNumber: 'api/registratura/document/generabile/seal/check-registru-number/', // + documentId/serieId
                        registerExtended: 'api/registratura/document/generabile/seal/register-extended/', // + documentId
                        downloadForSigning: 'api/registratura/document/generabile/seal/download-for-signing/', // + documentId
                        applySeal: 'api/registratura/document/generabile/seal/apply-seal/', // + documentId
                    },

                    // Document Finalization endpoints
                    finalize: 'api/registratura/document/generabile/finalizare/', // + documentId
                    sendToSRP: 'api/registratura/document/generabile/trimite-srp/', // + documentId
                    finalizeSRP: 'api/registratura/document/generabile/finalizare-srp/', // + documentId
                    // Reset operațiuni finalizare - necesită permisiuni speciale
                    resetFinalize: 'api/registratura/document/generabile/reset-finalizare/', // documentId
                    resetSendToSRP: 'api/registratura/document/generabile/reset-trimite-srp/', // documentId
                    resetFinalizeSRP: 'api/registratura/document/generabile/reset-finalizare-srp/', // documentId
                },
                signatures: {
                    getListIds:
                        'api/registratura/document/generabile/signatures/allocated/', // + id document + doc_type
                    updateIds:
                        'api/registratura/document/generabile/signatures/allocated/', // + id document
                    updateSignatures:
                        'api/registratura/document/generabile/signatures/update-signatures',
                },

                // AWB
                storeAWB: 'api/registratura/document/awb',
                findAWB: 'api/registratura/document/find-awb/', // + id
                updateAWB: 'api/registratura/document/update-awb/', // + id
                duplicateAWB: 'api/registratura/document/duplicate-awb/', // + id
            },
            nomenclatoare: {
                registratura: {
                    prioritati: {
                        list: 'api/registratura/priorities/list',
                        listDT: 'api/registratura/priorities/list-dt',
                        listActive: 'api/registratura/priorities/list/active',
                        listPublic: 'api/registratura/priorities/list/public',
                        find: 'api/registratura/priorities/find/', // + id
                        store: 'api/registratura/priorities/store',
                        update: 'api/registratura/priorities/update', // id in payload
                        delete: 'api/registratura/priorities/delete/', // + id
                        active: 'api/registratura/priorities/status/active/', // + id
                        public: 'api/registratura/priorities/status/public/', // + id
                    },
                    status: {
                        list: 'api/registratura/status/list',
                        listDT: 'api/registratura/status/list-dt',
                        listActive: 'api/registratura/status/list/active',
                        listPublic: 'api/registratura/status/list/public',
                        find: 'api/registratura/status/find/', // + id
                        store: 'api/registratura/status/store',
                        update: 'api/registratura/status/update', // id in payload
                        delete: 'api/registratura/status/delete/', // + id
                        active: 'api/registratura/status/status/active/', // + id
                        public: 'api/registratura/status/status/public/', // + id
                        archive: 'api/registratura/status/archive/', // + id
                        updateOrder: 'api/registratura/status/order/', // + id => put request
                    },
                    serie: {
                        list: 'api/registratura/serii/list',
                        listDT: 'api/registratura/serii/list-dt',
                        listActive: 'api/registratura/serii/list/active',
                        listPublic: 'api/registratura/serii/list/public',
                        find: 'api/registratura/serii/find/', // + id
                        store: 'api/registratura/serii/store',
                        update: 'api/registratura/serii/update', // id in payload
                        delete: 'api/registratura/serii/delete/', // + id
                        active: 'api/registratura/serii/status/active/', // + id
                        public: 'api/registratura/serii/status/public/', // + id
                        updateNumarCurent: 'api/registratura/serii/update-numar-curent/', // + id
                        newNumbersBlock: 'api/registratura/serii/new-numbers-block/', // + id
                        archive: 'api/registratura/serii/archive/', // + id
                    },
                    surse: {
                        list: 'api/registratura/sources/list',
                        listDT: 'api/registratura/sources/list-dt',
                        listActive: 'api/registratura/sources/list/active',
                        listPublic: 'api/registratura/sources/list/public',
                        find: 'api/registratura/sources/find/', // + id
                        store: 'api/registratura/sources/store',
                        update: 'api/registratura/sources/update', // id in payload
                        delete: 'api/registratura/sources/delete/', // + id
                        active: 'api/registratura/sources/status/active/', // + id
                        public: 'api/registratura/sources/status/public/', // + id
                    },
                    adreseRedirect: {
                        list: 'api/registratura/adrese-redirect/index',
                        listDT: 'api/registratura/adrese-redirect/indexDT',
                        listActive: 'api/registratura/adrese-redirect/list/active',
                        listPublic: 'api/registratura/adrese-redirect/list/public',
                        find: 'api/registratura/adrese-redirect/find/', // + id
                        store: 'api/registratura/adrese-redirect/store',
                        update: 'api/registratura/adrese-redirect/update', // id in payload
                        delete: 'api/registratura/adrese-redirect/delete/', // + id
                        active: 'api/registratura/adrese-redirect/status/update/', // + id
                        public: 'api/registratura/adrese-redirect/status/public/', // + id
                    },
                    zileLibere: {
                        list: 'api/registratura/holidays/list',
                        listDT: 'api/registratura/holidays/list-dt',
                        listActive: 'api/registratura/holidays/list/active',
                        listPublic: 'api/registratura/holidays/list/public',
                        find: 'api/registratura/holidays/find/', // + id
                        store: 'api/registratura/holidays/store',
                        update: 'api/registratura/holidays/update', // id in payload
                        delete: 'api/registratura/holidays/delete/', // + id
                        active: 'api/registratura/holidays/status/active/', // + id
                        public: 'api/registratura/holidays/status/public/', // + id
                    },
                    entityTypes: {
                        list: 'api/registratura/entity-types/list',
                        listDT: 'api/registratura/entity-types/list-dt',
                        listActive: 'api/registratura/entity-types/list/active',
                        listPublic: 'api/registratura/entity-types/list/public',
                        find: 'api/registratura/entity-types/find/', // + id
                        store: 'api/registratura/entity-types/store',
                        update: 'api/registratura/entity-types/update', // id in payload
                        delete: 'api/registratura/entity-types/delete/', // + id
                        active: 'api/registratura/entity-types/status/active/', // + id
                        public: 'api/registratura/entity-types/status/public/', // + id
                    },
                    documentTypes: {
                        list: 'api/registratura/document-types/list',
                        listDT: 'api/registratura/document-types/list-dt',
                        listActive: 'api/registratura/document-types/list/active',
                        listPublic: 'api/registratura/document-types/list/public',
                        find: 'api/registratura/document-types/find/', // + id
                        store: 'api/registratura/document-types/store',
                        update: 'api/registratura/document-types/update', // id in payload
                        delete: 'api/registratura/document-types/delete/', // + id
                        active: 'api/registratura/document-types/status/active/', // + id
                        public: 'api/registratura/document-types/status/public/', // + id
                    },
                    categorii: {
                        list: 'api/registratura/categorii/list',
                        listDT: 'api/registratura/categorii/list-dt',
                        listActive: 'api/registratura/categorii/list/active',
                        listPublic: 'api/registratura/categorii/list/public',
                        find: 'api/registratura/categorii/find/', // + id
                        store: 'api/registratura/categorii/store',
                        update: 'api/registratura/categorii/update', // id in payload
                        delete: 'api/registratura/categorii/delete/', // + id
                        active: 'api/registratura/categorii/status/active/', // + id
                        public: 'api/registratura/categorii/status/public/', // + id
                    },
                    tipuri: {
                        list: 'api/registratura/tipuri/list',
                        listDT: 'api/registratura/tipuri/list-dt',
                        listActive: 'api/registratura/tipuri/list/active',
                        listPublic: 'api/registratura/tipuri/list/public',
                        find: 'api/registratura/tipuri/find/', // + id
                        store: 'api/registratura/tipuri/store',
                        update: 'api/registratura/tipuri/update', // id in payload
                        delete: 'api/registratura/tipuri/delete/', // + id
                        active: 'api/registratura/tipuri/status/active/', // + id
                        public: 'api/registratura/tipuri/status/public/', // + id
                        search: 'api/registratura/tipuri/search',
                    },
                    finalizareTypes: {
                        list: 'api/registratura/finalizare-types/list',
                        listDT: 'api/registratura/finalizare-types/list-dt',
                        listActive: 'api/registratura/finalizare-types/list/active',
                        listPublic: 'api/registratura/finalizare-types/list/public',
                        find: 'api/registratura/finalizare-types/find/', // + id
                        store: 'api/registratura/finalizare-types/store',
                        update: 'api/registratura/finalizare-types/update', // id in payload
                        delete: 'api/registratura/finalizare-types/delete/', // + id
                        active: 'api/registratura/finalizare-types/status/active/', // + id
                        public: 'api/registratura/finalizare-types/status/public/', // + id
                    },
                    directieSerii: {
                        list: 'api/directie-serii/list',
                        listDT: 'api/directie-serii/list-dt',
                        listActiveRecord: 'api/directie-serii/list-active/record',
                        find: 'api/directie-serii/find/', // + id directie/id compartiment
                        store: 'api/directie-serii/store',
                        update: 'api/directie-serii/update', // + id directie/id compartiment
                        delete: 'api/directie-serii/delete/', // + id directie/id compartiment
                        remove: 'api/directie-serii/remove/', // + id directie/id compartiment/id serie
                        active: 'api/directie-serii/status/active/', // + id directie/id compartiment
                        public: 'api/directie-serii/status/public/', // + id directie/id compartiment
                        blocare: 'api/directie-serii/status/blocare/', // + id directie/id compartiment
                        activeSwitch: 'api/directie-serii/active-switch',
                        updatePrefix: 'api/directie-serii/update-prefix/', // + directie/compartiment
                        updateDirectiiCompartimenteSerii: 'api/directie-serii/update-directii-compartimente-serii',
                        statusActiveMass: 'api/directie-serii/status/active-mass',
                        statusPublicMass: 'api/directie-serii/status/public-mass',
                        updateRecords: 'api/directie-serii/update/records',
                    },
                    emailsBlacklist: {
                        list: 'api/emails-blacklist/list',
                        listDT: 'api/emails-blacklist/list-dt',
                        find: 'api/emails-blacklist/find/', // + id
                        store: 'api/emails-blacklist/store',
                        update: 'api/emails-blacklist/update', // id in payload
                        delete: 'api/emails-blacklist/delete/', // + id
                        status: 'api/emails-blacklist/status/', // + id
                    },
                    operatori: {
                        listDT: 'api/user/list-module-users',
                        getOperatorPermisiuniList: 'api/operatori/operator-cereri-permissions-list/', // + id
                        updateOperatorPermisiuni: 'api/operatori/update-cereri-permissions/', // + id
                        getOperatorFunctie: 'api/operatori/operator-cereri-functie/', // + user_id
                        updateOperatorFunctie: 'api/operatori/operator-cereri-functie-update/', // user_id, payload {functie_id}
                        getOperatoriByCompartiment: 'api/operatori/operator-compartment-list/', // + id_compartiment
                        getOperatorAccess: 'api/registratura/operatori/get-operator-access', // get user by token
                        operatorAccessList: 'api/user/operator-access-list',
                        operatorAccessListDt: 'api/registratura/operatori/operator-access-list-dt', // id_user in payload list-dt
                        allocateOperatorAccess: 'api/registratura/operatori/allocate-operator-access', // id_user in payload
                        deleteOperatorAccess: 'api/registratura/operatori/delete-operator-access/', // + id_access
                        activeOperatorAccess: 'api/registratura/operatori/active-operator-access/', // + id_access

                        // Multi-function endpoints
                        getUserMultipleFunctii: 'api/operatori/operator-cereri-functii-multiple/', // + user_id
                        updateUserMultipleFunctii: 'api/operatori/operator-cereri-functii-multiple-update/', // + user_id
                        setActiveFunctie: 'api/operatori/operator-cereri-functie-set-active/', // + user_id
                        getActiveFunctie: 'api/operatori/operator-cereri-functie-active/', // + user_id
                        getUserFunctiiList: 'api/operatori/operator-cereri-functii-list/', // + user_id
                        userHasFunctions: 'api/operatori/operator-has-functions/', // + user_id

                        // Enhanced features endpoints
                        functieHistory: 'api/operatori/functie-history/', // + user_id
                        functieHistoryExport: 'api/operatori/functie-history-export/', // + user_id
                        functieHistoryStatistics: 'api/operatori/functie-history-statistics',
                        recentFunctionChanges: 'api/operatori/recent-function-changes',
                        bulkAssignmentUsers: 'api/operatori/bulk-assignment/users',
                        bulkAssignmentPreview: 'api/operatori/bulk-assignment/preview',
                        bulkAssignmentExecute: 'api/operatori/bulk-assignment/execute',
                        bulkAssignmentHistory: 'api/operatori/bulk-assignment/history',
                        bulkAssignmentTemplates: 'api/operatori/bulk-assignment/templates',
                    },
                    general: {
                        list: 'api/registratura/configuration/list',
                        update: 'api/registratura/configuration/update',
                        updateMultiple: 'api/registratura/configuration/multiple-configuration',
                        clearCache: 'api/registratura/configuration/clear-app-cache'
                    },
                    statusPosta: {
                        listDT: 'api/registratura/status-posta/list-dt',
                        list: 'api/registratura/status-posta/list',
                        listActive: 'api/registratura/status-posta/list/active',
                        listPublic: 'api/registratura/status-posta/list/public',
                        active: 'api/registratura/status-posta/status/active/', // + id
                        public: 'api/registratura/status-posta/status/public/', // + id
                        populate: 'api/registratura/oficiu-postal/populate',
                    },
                    oficiuPostal: {
                        listDT: 'api/registratura/oficiu-postal/list-dt',
                        list: 'api/registratura/oficiu-postal/list',
                        listActive: 'api/registratura/oficiu-postal/list/active',
                        listPublic: 'api/registratura/oficiu-postal/list/public',
                        active: 'api/registratura/oficiu-postal/status/active/', // + id
                        public: 'api/registratura/oficiu-postal/status/public/', // + id
                        populate: 'api/registratura/oficiu-postal/populate',
                    },
                    templateCategories: {
                        listDT: 'api/registratura/template-categories/datatable',
                        store: 'api/registratura/template-categories',
                        update: 'api/registratura/template-categories/', // + id
                        delete: 'api/registratura/template-categories/', // + id
                        active: 'api/registratura/template-categories/', // + id + /status
                        public: 'api/registratura/template-categories/', // + id + /visibility
                    },
                    documentTemplate: {
                        list: 'api/registratura/document-templates/list',
                        listDT: 'api/registratura/document-templates/list-dt',
                        one: 'api/registratura/document-templates/find/', // + id
                        templateById: 'api/registratura/document-templates/get-official-doc-template/', // template_id
                        store: 'api/registratura/document-templates/store',
                        update: 'api/registratura/document-templates/update', // id in payload
                        active: 'api/registratura/document-templates/updateStatusActive/', // + id
                        delete: 'api/registratura/document-templates/delete/', // + id
                        previewDocument: 'api/registratura/document-templates/preview/', // + type/id
                        signatures: {
                            getListIds:
                                'api/registratura/document-templates/signatures/allocated/', // + id template
                            updateIds:
                                'api/registratura/document-templates/signatures/allocated/', // + id template
                            updateOrder:
                                'api/registratura/document-templates/signatures/update-order/', // + id signature
                            updateSignType:
                                'api/registratura/document-templates/signatures/update-sign-type/', // + id
                            updateSignatures:
                                'api/registratura/document-templates/signatures/update-signatures',
                        },
                        filters: {
                            categoriesSearch: 'api/registratura/document-templates/filters/categories/search',
                        },
                        clone: {
                            preview: 'api/registratura/document-templates/clone/preview',
                            documentTemplate: 'api/registratura/document-templates/clone/document-template/', // + templateId
                        },
                    },
                    documentHeaders: {
                        list: 'api/document-headers/list',
                        listDT: 'api/document-headers/list-dt',
                        listActive: 'api/document-headers/list/active',
                        default: 'api/document-headers/default',
                        find: 'api/document-headers/find/', // + id
                        store: 'api/document-headers/store',
                        update: 'api/document-headers/update', // id in payload
                        delete: 'api/document-headers/delete/', // + id
                        setDefault: 'api/document-headers/set-default/', // + id
                        toggleActive: 'api/document-headers/toggle-active/', // + id
                        uploadImage: 'api/document-headers/upload-image',
                    },
                    documentFooters: {
                        list: 'api/document-footers/list',
                        listDT: 'api/document-footers/list-dt',
                        listActive: 'api/document-footers/list/active',
                        default: 'api/document-footers/default',
                        find: 'api/document-footers/find/', // + id
                        store: 'api/document-footers/store',
                        update: 'api/document-footers/update', // id in payload
                        delete: 'api/document-footers/delete/', // + id
                        setDefault: 'api/document-footers/set-default/', // + id
                        toggleActive: 'api/document-footers/toggle-active/', // + id
                        uploadImage: 'api/document-footers/upload-image',
                        previewPagination: 'api/document-footers/preview-pagination',
                    },
                },
                administrative: {
                    storage: {
                        list: 'api/registratura/storage-locations/list',
                        listDT: 'api/registratura/storage-locations/list-dt',
                        listActive: 'api/registratura/storage-locations/list/active',
                        listPublic: 'api/registratura/storage-locations/list/public',
                        find: 'api/registratura/storage-locations/find/', // + id
                        store: 'api/registratura/storage-locations/store',
                        update: 'api/registratura/storage-locations/update', // id in payload
                        delete: 'api/registratura/storage-locations/delete/', // + id
                        active: 'api/registratura/storage-locations/status/active/', // + id
                        public: 'api/registratura/storage-locations/status/public/', // + id
                    },
                    crons: {
                        list: 'api/registratura/crons/list',
                        listDT: 'api/registratura/crons/list-dt',
                        listActive: 'api/registratura/crons/list-active',
                        store: 'api/registratura/crons/store',
                        update: 'api/registratura/crons/update',
                        updateStatus: 'api/registratura/crons/status/active/',
                        delete: 'api/registratura/crons/delete/',
                    },
                    configurations: {
                        list: 'api/registratura/configuration/list',
                        listDT: 'api/registratura/configuration/list-dt',
                        find: 'api/registratura/configuration/one/', // + id
                        store: 'api/registratura/configuration/store',
                        update: 'api/registratura/configuration/update', // id in payload
                    },
                    signer: {
                        health: 'api/registratura/signer/health',
                        ready: 'api/registratura/signer/ready',
                        certificates: 'api/registratura/signer/certificates',
                        certificateBySlug: 'api/registratura/signer/certificates/', // + slug
                        rateLimit: 'api/registratura/signer/rate-limit/', // + slug
                        configuration: 'api/registratura/signer/configuration',
                        testConnection: 'api/registratura/signer/test-connection',
                        testSign: 'api/registratura/signer/test-sign/', // + slug
                        syncCertificates: 'api/registratura/signer/sync-certificates',
                        watermarkPreview: 'api/registratura/signer/watermark-preview',
                        downloadFile: 'api/registratura/signer/download-file/', // + requestId
                        // Logo endpoints
                        logoStatus: 'api/registratura/signer/certificates/logo-status',
                        uploadLogo: 'api/registratura/signer/certificates/', // + slug + '/logo'
                        deleteLogo: 'api/registratura/signer/certificates/', // + slug + '/logo'
                        toggleLogo: 'api/registratura/signer/certificates/', // + slug + '/logo-enabled'
                        logs: {
                            signing: 'api/registratura/signer/logs/signing',
                            signingDetail: 'api/registratura/signer/logs/signing/', // + logId
                            signingExport: 'api/registratura/signer/logs/signing/export/csv',
                            signingStatuses: 'api/registratura/signer/logs/meta/statuses',
                            audit: 'api/registratura/signer/logs/audit',
                            auditDetail: 'api/registratura/signer/logs/audit/', // + logId
                            auditExport: 'api/registratura/signer/logs/audit/export/csv',
                            auditActions: 'api/registratura/signer/logs/meta/actions',
                            stats: 'api/registratura/signer/logs/stats',
                        },
                    },
                    operatorSigningLogs: {
                        list: 'api/registratura/document/operator-signature/logs',
                        detail: 'api/registratura/document/operator-signature/logs/', // + logId
                        statuses: 'api/registratura/document/operator-signature/logs/statuses',
                        export: 'api/registratura/document/operator-signature/logs/export/csv',
                        signingStatus: 'api/registratura/document/generabile/operator-signature/log/status/', // + documentGeneratId
                    },
                },
            },
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            linkRedirectAuth: 'https://development.app.webproductionlabs.com/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve
 */
